export default __webpack_public_path__ + "static/media/civil-ensign-of-luxembourg.55831977.svg";